<header [class.header-pf]="!isCasasBahia">
  <img *ngIf="isCasasBahia" src="/assets/images/layout/header-lines-cb.svg" class="header-lines" width="100%" height="100%">
  
  <div *ngIf="!(isMinorThanTablet | async).matches" class="header-content">
    <img *ngIf="isCasasBahia" src="/assets/images/pagamento_renngociacao_header.svg" alt="Logo Casas Bahia" class="brand-cb-text">
    <img *ngIf="!isCasasBahia" src="/assets/images/layout/header-logo-pf-white.svg" alt="Logo Pontofrio" class="brand-pf-text">
    <div class="security-info">
      <span>
        <svg width="13" height="16" xmlns="http://www.w3.org/2000/svg">
          <use xlink:href="/assets/images/icons/ic-security-lock.svg#lock" fill="inherit" />
        </svg>
        Ambiente 100% seguro
      </span>
    </div>
  </div>

  <img *ngIf="!isCasasBahia" src="/assets/images/layout/header-lines-pf.svg" class="header-lines" width="100%" height="100%">

  <div *ngIf="(isMinorThanTablet | async).matches" class="mobile-header">
    <button *ngIf="isCasasBahia" (click)="handleGoBack()" class="go-back-btn cb">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button *ngIf="!isCasasBahia" (click)="handleGoBack()" class="go-back-btn pf">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
</header>

<div *ngIf="(isMinorThanTablet | async).matches" class="brand-out-header">
  <img *ngIf="isCasasBahia" src="/assets/images/pagamento_renngociacao_header.svg" alt="Logo Casas Bahia" class="brand-cb-text">
  <img *ngIf="!isCasasBahia" src="/assets/images/layout/header-logo-pf-dark.svg" alt="Logo Casas Bahia" class="brand-cb-text">
</div>
